import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { TextField, ButtonLoader, Error, PasswordLogin, PageLoader, MobileNumber } from "components";
import { AuthLayout } from "layouts";
import * as actions from "store/actions";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// import { useClearCache } from 'react-clear-cache';
// import { ClearCacheProvider, useClearCacheCtx, useClearCache } from 'react-clear-cache';

const Login = (props) => {
	const history = useHistory();
	const { user, user_loading, user_error } = props.authorization;
	const { login, clearAuthorizationError, getUIoptions, uioptions, logout, clearUIoptionsError } =
		props;

	
	// const { isLatestVersion, emptyCacheStorage } = useClearCache();
	// const { isLatestVersion, emptyCacheStorage } = useClearCache();

	const [resetType, setResetType] = useState("email");

	const initialValues = {
		email: "",
		mobile: "",
		password: "",
	};

	useEffect(() => {
		let subscribe = true;
		if (subscribe) document.title = "Access Forex | Login";
		return () => {
			subscribe = false;
		};
	}, []);

	useEffect(() => {
		logout();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		getUIoptions();
	}, [getUIoptions]);

	const schemaObject = {
		password: Yup.string().required().label("Password")
	};

	if (resetType === "mobile") schemaObject.mobile = Yup.string().required().label("Mobile Number");
	if (resetType === "email")
		schemaObject.email = Yup.string()
			.email("Invalid email address")
			.required("Email address is required");

	const loginSchema = Yup.object().shape(schemaObject);

	// const loginSchema = Yup.object().shape({
	// 	email: Yup.string().email("Invalid email address").required("Email address is required"),
	// 	password: Yup.string().required().label("Password"),
	// });

	useEffect(() => {
		user && history.push("/send-money");
		return () => {
			clearAuthorizationError();
		};
	}, [user, history, clearAuthorizationError]);

	const handleLogin = (formData) => {
		login(formData);
	};

	useEffect(() => {
		const time_id = setInterval(() => {
			user_error && clearAuthorizationError();
		}, 9000);

		return () => {
			clearTimeout(time_id);
		};
	}, [user_error, clearAuthorizationError]);


	// Function to clear complete cache data
	// const clearCacheData = () => {
	// 	caches.keys().then((names) => {
	// 		names.forEach((name) => {
	// 			caches.delete(name);
	// 		});
	// 	});
	// 	console.log('Complete Cache Cleared')
	// };


	useEffect(() => {
		// clearCacheData();
		// if (!isLatestVersion) {
		// 	console.log("Different version detected.");
		// 	clearCacheData();
		// 	emptyCacheStorage();
		// } else {
		// 	console.log("Version is up to date.");
		// 	clearCacheData();
		// }
	}, []);


	let content = uioptions.ui_loading ? (
		<PageLoader />
	) : (
		<AuthLayout uioptions={uioptions} clearUIoptionsError={clearUIoptionsError} pagetitle="LOGIN">
			{
				<Formik
					initialValues={initialValues}
					validationSchema={loginSchema}
					onSubmit={(values, { setSubmitting, resetForm }) => {
						setSubmitting(true);
						values.type = resetType;
						let newFormData = values;
						if (newFormData.mobile) {
							let mob = `+${newFormData.mobile}`
							newFormData.mobile = `+${newFormData.mobile}`;
						}
						handleLogin(newFormData);
						// alert(JSON.stringify(values));
						setSubmitting(false);
					}}
				>
						{({ setFieldValue, ...formik }) => (
						<Form>
							<p className="mt-0 mb-0">
								<Link
									to="/register"
									style={{
										textDecoration: "none",
										color: "#3B366F",
									}}
								>
									Not yet a member? <strong>Sign Up</strong>
								</Link>
							</p>
							{user_error && user_error.map((err) => <Error key={err.error} error={err.error} />)}
							{/* <p className="mt-4">LOG IN</p> */}
							{/* <TextField label="Email*" name="email" /> */}

								<div className="row">
									{resetType === "mobile" ? (
										<div className="form-group mobile-input-container">
											{/* <label className="p-d-block fw-bold">Mobile Number*</label> */}
											{/* <PhoneInput
												name="mobile"
												country={"zw"}
												// value={values.mobile}
												// onChange={(mobile) => setFieldValue("mobile", mobile)}
												// onBlur={handleBlur}
												placeholder=""
												containerClass={`phone-input`}
												autoFormat={false}
											/> */}

											<MobileNumber
												label="Mobile Number*"
												name="phone"
												value={formik.values.mobile}
												// disabled={disableFields}
												inputProps={{
													name: "mobile",
													placeholder: "Enter mobile number",
												}}
												country={"zw"}
												onlyCountries={["zw"]}
												onBlur={formik.handleBlur}
												onChange={(value, country, e) => {
													formik.handleChange(e);
													setFieldValue("mobile", value);
												}}
											/>
											{formik.errors && formik.errors.phone && (
												<span className="form-text small text-danger mt-0">
													{formik.errors.phone}
												</span>
											)}
										
										</div>
									) : (
										<>
											<div className="form-group mobile-input-container">
												<TextField label="Email*" name="email" />
											</div>
										</>
									)}

									<center>
										<strong
											align="center"
											onClick={() => {
												if (resetType === "email") {
												}
												setResetType(resetType === "email" ? "mobile" : "email");
											}}
											style={{ cursor: "pointer", color: '#fecb3e' }}
										>
											Login using {resetType === "email" ? "Mobile Number" : "Email"}
										</strong>
									</center>

								</div>

							

							<PasswordLogin label="Password*" name="password" />
							{/* <TextField label="Password*" name="password" type="password" /> */}
							<div className="d-grid gap-2 mt-3">
								{user_loading ? (
									<ButtonLoader />
								) : (
									<button className="btn btn-primary bgBlue" type="submit">
										<i className="pi pi-lock"></i> Sign In (MUNASHE)
									</button>
								)}
							</div>

							<p className="mt-2 mb-0">
								<Link
									to="/reset-password-link"
									style={{
										textDecoration: "none",
										color: "#3B366F",
									}}
								>
									Forgot your password? <strong>Reset Password</strong>
								</Link>
							</p>
						</Form>
					)}
				</Formik>
			}
		</AuthLayout>
	);

	return <>{content}</>;
};

Login.propTypes = {
	authorization: PropTypes.object.isRequired,
	login: PropTypes.func.isRequired,
	uioptions: PropTypes.object.isRequired,
	getUIoptions: PropTypes.func.isRequired,
	clearUIoptionsError: PropTypes.func.isRequired,
	clearAuthorizationError: PropTypes.func.isRequired,
	logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
	authorization: state.authorization,
	uioptions: state.uioptions,
});

export default connect(mapStateToProps, actions)(Login);
